<template>
  <el-dialog
    :title="$t('text.apply_theme')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    width="600px"
    class="apply-theme"
  >
    <div class="warn-info">
      {{ $t('text.apply_theme_warning') }}
    </div>
    <el-form
      :model="form"
      :rules="rules"
      label-position="top"
      ref="form"
      class="mt-10"
    >
      <el-form-item prop="domain">
        <el-input
          v-model="form.domain"
          :placeholder="$t('text.domain_name')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button
        type="primary"
        :loading="applyCurrentDomainLoading"
        :disabled="applyCurrentDomainLoading"
        class="save-btn min-w-80 float-left"
        @click="applyToThisDomain"
        >{{ $t('text.apply_to_current_domain') }}</el-button
      >
      <el-button
        type="primary"
        :loading="loading"
        :disabled="loading"
        class="save-btn min-w-80"
        @click="apply('dynamicValidateForm')"
        >{{ $t('text.apply_to_entered_domain') }}</el-button
      >
      <el-button @click="closeDialog()" class="cancel-btn">{{
        $t('text.cancel')
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import $ from 'jquery'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      applyCurrentDomainLoading: false,
      form: {
        domain: ''
      },
      rules: {
        domain: [
          {
            required: true,
            message: this.$t('text.please_enter_domain_name'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },
    calcLoading(isCurrentDomain, loading) {
      if (isCurrentDomain) {
        this.applyCurrentDomainLoading = loading
      } else {
        this.loading = loading
      }
    },
    applyToThisDomain() {
      this.form.domain = document.domain
      this.handleApply(true)
    },
    apply() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.handleApply(false)
        }
      })
    },
    handleApply(isCurrentDomain) {
      this.calcLoading(isCurrentDomain, true)
      let parent = this.$parent
      ApiService.ApplyTheme({
        manufacturerName: this.form.domain,
        themeValue: JSON.stringify({
          colors: $.extend(
            {},
            this.$store.state.customization.colorObj,
            parent.$refs.colors.selectedColorObj
          ),
          font: parent.$refs.font.activeFont,
          logo: parent.$refs.logo.logo,
          isCircleLogo: parent.$refs.logo.isCircleLogo,
          loginBg: parent.$refs.loginBg.loginBg,
          topNavBg: parent.$refs.topNavBg.topNavBg,
          topNavBgOpacity: parent.$refs.topNavBg.topNavBgOpacity,
          menuBg: parent.$refs.menuBg.menuBg,
          menuBgOpacity: parent.$refs.menuBg.menuBgOpacity,
          mainContentBg: parent.$refs.mainContentBg.mainContentBg,
          mainContentBgOpacity: parent.$refs.mainContentBg.mainContentBgOpacity,
          fontSize: parent.$refs.font.fontSizeForm,
          fontColor: parent.$refs.font.fontColorForm
        })
      })
        .then(response => {
          this.closeDialog()
          this.calcLoading(isCurrentDomain, false)
          this.$store.dispatch('customization/getCustomTheme')
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.apply_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.closeDialog()
          this.calcLoading(isCurrentDomain, false)
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.warn-info {
  color: #f56c6c;
  font-size: 12px;
  line-height: 16px;
  word-break: break-word;
}
</style>
